import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { ApiRequestDispatcherService } from "../../../../shared-library/services/api/api-request-dispatcher.service";
import { ApiResponseDispatcherService } from "../../../../shared-library/services/api/api-response-dispatcher.service";

import { BaseSearchResultsModel } from "../../../models/base-search-results.model";

import { ContentItemModel } from "../models/content-item.model";
import { ContentSearchParametersModel } from "../models/content-search-parameters.model";

@Injectable({
    providedIn: "root"
})
export class ContentSearchService {
    private readonly API_GET_LIST_URL = "/api/s4s-advanced-search/content-search/get-list";

    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService,
        private _responseDispatcher: ApiResponseDispatcherService
    ) {
    }

    public getSearchResults(searchParams: ContentSearchParametersModel): Observable<BaseSearchResultsModel<ContentItemModel>> {
        const response$ = this._requestDispatcher.get<BaseSearchResultsModel<ContentItemModel>>(this.API_GET_LIST_URL, { searchParams: JSON.stringify(searchParams) });
        return this._responseDispatcher.unwrap(response$);
    }
}
